module.exports = __webpack_public_path__ + "img/users.2298fc51.svg";